import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  NgZone,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { HttpService } from '../../services/common/http/common.http.service';
import { IPostRecuperarSenha } from './email-senha.model.layout';

@Component({
  selector: 'app-email-senha-layout',
  templateUrl: './email-senha.component.html',
  styleUrl: './email-senha.component.scss',
})
export class EmailSenhaComponent {
  @Output() loginEvent = new EventEmitter<IPostRecuperarSenha>();
  emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  loader: boolean = false;

  login: IPostRecuperarSenha = {
    TxEmail: '',
  };

  constructor(private httpService: HttpService, private router: Router) {}

  ngOnInit() {
    localStorage.clear();
    window.addEventListener('resize', this.updateCorLabel.bind(this));
  }

  loginSubmit() {
    this.loader = true;

    const payload = {
      TxEmail: this.login.TxEmail,
    };

    this.httpService.usePostFilter('EsqueciSenha', payload).subscribe({
      next: (response: any) => {
        const data = response.DataSet;

        Swal.fire({
          title: 'Sucesso!',
          text: 'Um e-mail com o link de redefinição foi enviado para o seu e-mail.',
          icon: 'success',
          confirmButtonColor: 'green',
          confirmButtonText: 'Ok',
        });

        if (!response.IsSuccess) {
          Swal.fire({
            title: 'Atenção!',
            text: response.Message,
            icon: 'error',
            confirmButtonText: 'OK',
          });
          this.loader = false;
          return;
        }

        this.router.navigate(['login']);
        this.loader = false;
      },
      error: (error) => {
        Swal.fire({
          title: 'Atenção',
          text: error.error.Error.Login[0],
          icon: 'warning',
          confirmButtonColor: 'green',
          confirmButtonText: 'Confirmar',
        });
        this.loader = false;
      },
      complete: () => {
        this.loader = false;
      },
    });
  }

  updateCorLabel(): string {
    return window.innerWidth < 940 ? 'white' : 'black';
  }

  validarForm() {
    if (!this.login.TxEmail || !this.emailRegex.test(this.login.TxEmail)) {
      return false;
    }
    return true;
  }
}
